import React, { FC, ReactElement, useContext } from 'react'
import CLanguageHandler from '../../../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../../../../../React/Common/Contexts'
import { ConfigurableTableFieldForm } from '../../../../Molecules/ConfigurableTableFieldForm/ConfigurableTableFieldForm'
import { SETTINGS_CONFIG_FILE_NAME, SETTINGS_CONFIG_PATH } from '../Constants/Constants'
import { SettingsFieldNames, TabNames, TELEPHONY_SERVER_ID_FIELD_NAME } from '../Constants/FieldNames'
import { useTelSysType } from '../Hooks/useTelSysType'
import { ClientConfigurationModalLanguage } from '../../../../../../../i18n'

type Props = {
    isViewOnly?: boolean
}

export const ClientConfigurationSettingsTab: FC<Props> = ({ isViewOnly }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    const telSysType: Definable<string> = useTelSysType(TELEPHONY_SERVER_ID_FIELD_NAME)

    return (
        <div className='table-tab-content'>
            <ConfigurableTableFieldForm
                namespacingFunction={(name: string): string => `${TabNames.SETTINGS}.${name}`}
                localisationFunction={(name: string): string =>
                    language.get(`ClientConfigurationModal_Settings_${name}`)
                }
                config={[SETTINGS_CONFIG_FILE_NAME, SETTINGS_CONFIG_PATH]}
                arrayFieldName={SettingsFieldNames.SETTINGS}
                isViewOnly={isViewOnly}
                currentTelSysType={telSysType}
                allowAdd
                allowRemove
                showDefaults
                localisation={{
                    header: {
                        item: language.get(
                            ClientConfigurationModalLanguage.ClientConfigurationModal_Tab_Settings_SettingsItem
                        ),
                        default: language.get(
                            ClientConfigurationModalLanguage.ClientConfigurationModal_Tab_Settings_DefaultValue
                        ),
                        value: language.get(
                            ClientConfigurationModalLanguage.ClientConfigurationModal_Tab_Settings_ActualValue
                        )
                    }
                }}
            />
        </div>
    )
}
